export default __webpack_public_path__ + "static/media/user.6d7964c5.svg";